module.exports = __webpack_public_path__ + "static/img/200298.3ee52f22.png";